<template>
  <div ref="picEchart" style="height: 300px"></div>
</template>

<script>
export default {
  name: "pieSimple",
  mounted() {
    this.initEcharts();
  },
  methods: {
    initEcharts() {
      let chartDom = this.$refs.picEchart;
      let myChart = this.$echarts.init(chartDom);
      this.myChart = myChart;

      let option = {
        title: {
          text: "学员状态分布",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "人数",
            type: "pie",
            radius: "48%",
            data: [
              { value: 0, name: "未开始" },
              { value: 0, name: "未提交" },
              { value: 0, name: "未批阅" },
              { value: 0, name: "已完成" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    refreshData(data = []) {
      try {
        let option = this.myChart.getOption();
        option.series[0].data = data;
        this.myChart.setOption(option);
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>